import { widgetStore } from '../store';
import { useSelectedFieldStore } from './useSelectedFieldStore';

export type UseWidgetArg = {
  widgetId: string;
};

export function useWidget({ widgetId }: UseWidgetArg) {
  const widgetState = useSelectedFieldStore(
    widgetStore,
    () => widgetStore.get()[widgetId]?.widgetPayload
  );
  return widgetState;
}
